import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
    <mask
      id="calendar-icon_svg__a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="currentColor" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#calendar-icon_svg__a)">
      <path
        fill="currentColor"
        d="M4.5 18q-.618 0-1.06-.448A1.45 1.45 0 0 1 3 16.5v-11q0-.604.44-1.052A1.43 1.43 0 0 1 4.5 4H6V2h1.5v2h5V2H14v2h1.5q.619 0 1.06.448.44.449.44 1.052v11q0 .604-.44 1.052A1.43 1.43 0 0 1 15.5 18zm0-1.5h11V9h-11zm0-9h11v-2h-11zm5.504 4.5a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m-3.25 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m6.5 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m-3.25 3a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m-3.25 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m6.5 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219"
      />
    </g>
  </svg>
);
export default SvgCalendarIcon;
